var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center w-100 pa-0 ma-0",style:({
    width: '100%',
    height: _vm.Height || '500px',
    minHeight: _vm.Height || '500px',
    position: 'relative',
  })},[_c('canvas',{ref:"elemento",style:({
      maxHeight: _vm.Height || '500px',
      height: '100%',
      width: '100%',
    }),attrs:{"id":_vm.IdGrafico}})])
}
var staticRenderFns = []

export { render, staticRenderFns }